import { FormatHelper } from "../Helpers/FormatHelper.js";

export class RequestHelper {
    /**
     * [ajax description]
     * @param  {[String]} method [description]
     * @param  {[String]} url    [description]
     * @param  {[String]} data   [JSON]
     * @return {[type]}        [description]
     */
    static ajax(method, url, data, successCallback, errorCallback) {
        let pmApiUrl = (url.includes("api.dtm") || url.includes("pmm-api")) ? true : false;
        var xhttp = new XMLHttpRequest();
        url = method.toLowerCase() == "get" ? RequestHelper.getUrl(url, data) : url;
        xhttp.open(method, url, true);
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                // Response
                var response = this.responseText;
                if (successCallback) {
                    successCallback(response);
                }
            }
        };

        xhttp.onerror = () => {
            console.log("Error on ajax request");
            if (errorCallback) {
                errorCallback();
            }
        };

        xhttp.onloadend = function () {
            let response = this.responseText;
            if (xhttp.status == 404 || xhttp.status == 400) {
                if (errorCallback) {
                    errorCallback(response);
                }
            }
        };

        if (method.toLowerCase() == "get") {
            xhttp.send(null);
        } else {
            // add headers and stringify the data only if the request is not to save the lead
            if (!(data instanceof FormData)) {
                xhttp.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
                xhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                return xhttp.send(JSON.stringify(data));
            }

            xhttp.send(data);
        }
    }

    static ajaxv2({ method, url, data = null, headers = {}, successCallback, errorCallback }) {
        var xhttp = new XMLHttpRequest();
        url = method.toLowerCase() == "get" ? RequestHelper.getUrl(url, data) : url;
        xhttp.open(method, url, true);
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                // Response
                var response = this.responseText;
                if (successCallback) {
                    successCallback(response);
                }
            }
        };

        xhttp.onerror = () => {
            console.log("Error on ajax request");
            if (errorCallback) {
                errorCallback();
            }
        };

        xhttp.onloadend = function () {
            let response = this.responseText;
            if (xhttp.status == 404 || xhttp.status == 400) {
                if (errorCallback) {
                    errorCallback(response);
                }                
            }
        };
        // Set headers
        for (let key in headers) {
            xhttp.setRequestHeader(key, headers[key]);
        }
        
        if (method.toLowerCase() == "get") {
            xhttp.send(null);
        } else {
            // add headers and stringify the data only if the request is not to save the lead
            xhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            xhttp.setRequestHeader("Accept", "application/json");

            if (!(data instanceof FormData)) {
                xhttp.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
                return xhttp.send(JSON.stringify(data));
            }

            xhttp.send(data);
        }
    }

    static getUrl(url, data) {
        return url + "?" + FormatHelper.serialize(data);
    }

    static getIPAddress(successCallback, errorCallback) {
        if(RequestHelper.ipAddress) {//cache
            successCallback(RequestHelper.ipAddress);
            return;
        }

        const CLOUDFLARE = "https://www.cloudflare.com/cdn-cgi/trace";
        RequestHelper.ajax("GET", CLOUDFLARE, {},  
            (cloudFlareReponse) => {                
                let ip = cloudFlareReponse
                .split("\n")
                .filter((el) => el.startsWith("ip"))
                .join("\n")
                .substring(3);
                RequestHelper.ipAddress = ip;
                successCallback(RequestHelper.ipAddress);
            }, 
            errorCallback);
    }
}

RequestHelper.ipAddress = null;